import React from "react";
import Page from "@jumbo/shared/Page";
import DsokCustomerDetailProvider from "../data/DsokCustomerDetailProvider";
import DsokCustomerLocationsPage from "../pages/DsokCustomerLocationsPage";

export const dsokCustomerLocationsRoute = {
  path: "/dsok/customer-detail/:customerUrl/locations",
  element: (
    <DsokCustomerDetailProvider>
      <Page component={DsokCustomerLocationsPage} />
    </DsokCustomerDetailProvider>
  ),
};
